import { useContext, useEffect, useState } from 'react'
import Modal, { ModalBody, ModalHeader } from '../../../common/Modal'
import { ModulesContext, SET_SHOW_HIDE_MODULE_POPUP } from '../context/context'
import InputText from '../../../common/InputText'
import SelectInput from '../../../common/SelectInput'
import Button from '../../../common/Button'
import useDebouncedValue from '../../../../utils/common_function'
import { getRequest, postRequest } from '../../../../services/base'
import { useParams } from 'react-router-dom'

const ModuleForm = ({ onDataSave }) => {
  let { vehicle } = useParams()
  const [state, dispatch] = useContext(ModulesContext)
  const [connectorOptions, setConnectorOptions] = useState([])
  const [selectedConnectors, setSelectedConnectors] = useState([])
  const [searchConnector, setSearchConnector] = useState('')
  const debouncedToSearchConnector = useDebouncedValue(searchConnector, 1000)

  useEffect(() => {
    getConnectorList()
  }, [debouncedToSearchConnector])

  useEffect(() => {
    if (state?.selectedObject?.connector?.length > 0) {
      setSelectedConnectors(state?.selectedObject?.connector)
    }
  }, [state?.selectedObject?.connector])

  const getConnectorList = async () => {
    let res = await getRequest(
      `/api/connector/?vehicle=${vehicle}&search=${searchConnector}`
    )
    setConnectorOptions(
      res?.results?.map((connector) => ({
        name: connector.name,
        id: null,
        connector_id: connector.id,
      }))
    )
  }

  const saveModuleData = async (e) => {
    const formData = new FormData(e.target)

    let res = await postRequest(
      `/api/modules/save_modules/${vehicle}/`,
      formData
    )
    onDataSave(res?.status, res?.msg)
    closePopUp()
  }

  const closePopUp = () => {
    dispatch({
      type: SET_SHOW_HIDE_MODULE_POPUP,
      data: false,
    })
    setSelectedConnectors([])
    setSearchConnector('')
  }

  return (
    <Modal
      onClose={() => {
        closePopUp()
      }}
      show={state?.showModulesFormPopup}
    >
      <ModalHeader className={'text-white'}>Module's</ModalHeader>
      <ModalBody>
        <form
          onSubmit={(e) => {
            e.preventDefault()
            saveModuleData(e)
          }}
        >
          <div className="flex">
            <InputText
              name="acronym"
              value={state?.selectedObject?.acronym}
              onChange={(e) => {}}
              label={'Acronym'}
              type="text"
            />
            <InputText
              name="module_id"
              value={state?.selectedObject?.module_id}
              onChange={(e) => {}}
              label={'Module Id'}
              type="text"
              isRequired={false}
            />
          </div>
          <div className="flex">
            <SelectInput
              name="connectors"
              value={selectedConnectors}
              label="Module Connectors"
              optionLabel="name"
              optionValue="connector_id"
              options={connectorOptions}
              onChange={(value) => {
                setSelectedConnectors(value)
              }}
              isMulti={true}
              isRequired={false}
              onInputChange={(value) => {
                setSearchConnector(value)
              }}
            />
          </div>
          <div className="flex justify-end">
            <div className="w-1/3 px-2 mt-5">
              <Button
                type="submit"
                className={`cursor-pointer btn my-4 w-full justify-end pr-2`}
                onClick={(e) => {}}
                value={'text'}
                text={'Save Module'}
              />
            </div>
          </div>
        </form>
      </ModalBody>
    </Modal>
  )
}

export default ModuleForm
